import { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

export default function FilterSelect({
  label,
  name,
  options,
  value,
  onChange,
  multiple,
  width = 300,
}) {
  const [local, setLocal] = useState(value ?? (multiple ? [] : ""));

  /* Follow the value the parent passes, so a default that is only known once
     data has loaded, or a URL change from the back button, shows in the box. */
  useEffect(() => {
    setLocal(value ?? (multiple ? [] : ""));
  }, [value, multiple]);

  const handle = (e) => {
    setLocal(e.target.value);
    onChange(name, e.target.value);
  };

  /* The parent's value can lag a changed option list by a render, and a URL
     can carry a value the list no longer offers. MUI warns about either and
     shows nothing, so only a value the options contain reaches the Select. */
  const present = new Set(options.map((o) => String(o.value)));
  const safeValue = multiple
    ? (Array.isArray(local) ? local : []).filter((v) => present.has(String(v)))
    : present.has(String(local))
    ? local
    : "";

  return (
    <FormControl
      variant="outlined"
      style={{ width, minWidth: width, flexGrow: 1 }}
    >
      <InputLabel id={`${name}-label`} htmlFor={`${name}-label`}>
        {label}
      </InputLabel>
      <Select
        inputProps={{ id: `${name}-label` }}
        labelId={`${name}-label`}
        id={name}
        multiple={multiple}
        value={safeValue}
        onChange={handle}
        label={label}
      >
        {options.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
